import { LucideIconData } from 'lucide-angular';

export const PoolCaC46: LucideIconData = [
  ['circle', { cx: '12', cy: '12', r: '10' }],
  ['circle', { cx: '9', cy: '8', r: '1.5' }],
  ['circle', { cx: '9', cy: '16', r: '1.5' }],
  ['circle', { cx: '17', cy: '12', r: '1.5' }],
  ['path', { d: 'M11 8 H13V16H11' }],
  ['path', { d: 'M13 12 H15' }],
];
